"use client";

import {
  MenubarItem,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
} from "@oreme/ui";
import { useMapLibre } from "@/hooks";
import { useTranslations } from "next-intl";

function SharedMenubarViewZoom() {
  const t = useTranslations("global.MenubarViewZoom");
  const { map } = useMapLibre();

  const handleZoomIn = (): void => {
    map?.zoomIn();
  };

  const handleZoomOut = (): void => {
    map?.zoomOut();
  };

  return (
    <MenubarSub>
      <MenubarSubTrigger>{t("title")}</MenubarSubTrigger>
      <MenubarSubContent>
        <MenubarItem onClick={handleZoomIn}>{t("zoomIn")}</MenubarItem>
        <MenubarItem onClick={handleZoomOut}>{t("zoomOut")}</MenubarItem>
      </MenubarSubContent>
    </MenubarSub>
  );
}

export { SharedMenubarViewZoom };
